import { useState } from 'react';

/**
 * Latched blank-start state for a valuation form section (Phase 3A).
 *
 * A section starts collapsed ("+ Add X" button) and expands when the user
 * clicks the button OR when values exist (edit mode — initialData may load
 * after first render). Once expanded it never collapses, so clearing a field
 * back to 0 does not hide the inputs mid-edit.
 */
export function useBlankStart(hasValues: boolean): [expanded: boolean, expand: () => void] {
  const [added, setAdded] = useState(false);

  // Adjust-state-during-render latch (see react.dev "You Might Not Need an
  // Effect"): once values exist, stay expanded even if they are cleared.
  if (hasValues && !added) {
    setAdded(true);
  }

  return [added || hasValues, () => setAdded(true)];
}
